<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12 bg-white shadow-sm rounded-lg border mb-5">
                <form class="m-3" @submit.prevent="submit">
                    <!-- title -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.title }} <span class="required-star"></span>
                        </label>
                        <div class="col-sm-9">
                            <input
                                type="text"
                                class="form-control"
                                maxlength="50"
                                v-model="title"
                            />
                            <span class="text-danger" v-if="errors && errors.title">{{
                                errors.title[0]
                            }}</span>
                        </div>
                    </div>
                    <!-- Map -->
                    <div class="form-group row">
                        <span class="text-danger" v-if="getFirstCoordinatesError()">{{
                            getFirstCoordinatesError()
                        }}</span>
                        <div id="map" style="width: 100%; height: 800px" class="mh-75"></div>
                    </div>
                    <button
                        type="submit"
                        class="btn btn-primary w-25 center mb-4 mt-4 float-right"
                        :disabled="isDisabled"
                    >
                        {{ geofenceData ? trans.update : trans.create }}
                    </button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import MapBox from '../mixins/MapBox/Map';
import MapboxDraw from '@mapbox/mapbox-gl-draw';
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';
import * as turf from '@turf/turf';

export default {
    mixins: [MapBox],
    props: {
        formAction: {
            type: String,
            required: true
        },
        geofenceData: {
            type: Object,
            default: function () {
                return null;
            }
        },
        trans: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            draw: null,
            title: this.geofenceData ? this.geofenceData.title : '',
            errors: {},
            isDisabled: false
        };
    },
    methods: {
        initDraw() {
            this.draw = new MapboxDraw({
                displayControlsDefault: false,
                controls: {
                    polygon: true,
                    trash: true
                }
            });
            this.mySmartMap.addControl(this.draw);
            this.mySmartMap.on('draw.modechange', (e) => {
                const data = this.draw.getAll();
                if (this.draw.getMode() == 'draw_polygon') {
                    var pids = [];
                    const lid = data.features[data.features.length - 1].id;
                    data.features.forEach((f) => {
                        if (f.geometry.type === 'Polygon' && f.id !== lid) {
                            pids.push(f.id);
                        }
                    });
                    this.draw.delete(pids);
                }
            });
            if (this.geofenceData) {
                this.draw.add(this.geojson);
            }
        },
        submit() {
            var features = this.draw.getAll().features;
            var coordinates = [];
            features.forEach((feature) => {
                if (feature.geometry.coordinates.length > 0) {
                    if (feature.geometry.type == 'Polygon') {
                        coordinates.push(feature.geometry.coordinates[0]);
                    }
                }
            });
            this.isDisabled = true;
            var self = this;
            axios({
                method: this.geofenceData ? 'PUT' : 'POST',
                url: this.formAction,
                data: {
                    title: this.title,
                    coordinates: JSON.stringify(coordinates)
                }
            })
                .then((response) => {
                    if (response.data.redirectTo != undefined) {
                        window.location.replace(response.data.redirectTo);
                    }
                })
                .catch((error) => {
                    self.isDisabled = false;
                    if (error.response.status == 422) {
                        this.errors = {};
                        this.errors = error.response.data.errors;
                    }
                });
        },
        centerCameraByGeoFence() {
            var bbox = turf.bbox(turf.polygon(this.geofenceData.coordinates));
            var newCameraTransform = this.mySmartMap.cameraForBounds(bbox, {
                padding: { top: 10, bottom: 35, left: 15, right: 15 }
            });
            this.mySmartMap.jumpTo(newCameraTransform);
        },
        getFirstCoordinatesError() {
            if (this.errors.length == 0) {
                return;
            }

            for (const key in this.errors) {
                if (key.indexOf('coordinates') > -1) {
                    return this.errors[key][0];
                }
            }

            return;
        }
    },
    mounted() {
        this.initDraw();
        if (this.geofenceData) {
            this.centerCameraByGeoFence();
        }
    },
    computed: {
        geojson() {
            if (!this.geofenceData) return;

            var features = [];
            this.geofenceData.coordinates.forEach((el) => {
                features.push({
                    type: 'Feature',
                    properties: {},
                    geometry: {
                        coordinates: [el],
                        type: 'Polygon'
                    }
                });
            });

            return {
                type: 'FeatureCollection',
                features: features
            };
        }
    }
};
</script>
